<template>
  <v-drawer :direction="'right'" :width="'26%'">
    <div class="animated fadeInRightBig" style="height:100%;width:100%;">
      <div class="closeDraw">
        <el-button icon="el-icon-close" @click="closeClick"></el-button>
      </div>
      <div class="panel margin--bottom">
        <bar-card :bg="'border10'">
          <div class="jbxx">
            <div class="boxTitle">
              <v-title>基本信息</v-title>
            </div>
            <div class="boxContent">
              <div class="table_box">
                <div class="table_content">
                  <div class="content_title">
                    <span class="titleCont">农机名称</span>
                  </div>
                  <div class="content_info">
                    <span class="infoCont">
                      {{ infoList.njname_ ? infoList.njname_ : "" }}
                    </span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">操作机手</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.name ? infoList.name : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">机手电话</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.phone ? infoList.phone : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">在线时间</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.date ? infoList.date : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">速度</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.speed ? infoList.speed : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">俯仰角</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.fyj ? infoList.fyj : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_list">
                  <div class="table_title">
                    <span class="title">滚动角</span>
                  </div>
                  <div class="table_info">
                    <span class="info">{{
                      infoList.gdj ? infoList.gdj : "暂无数据"
                    }}</span>
                  </div>
                </div>
                <div class="table_content">
                  <div class="content_title">
                    <span class="titleCont">所在位置</span>
                  </div>
                  <div class="content_info">
                    <span class="infoCont">{{
                      infoList.address ? infoList.address : "暂无数据"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="zymj">
            <div class="boxTitle">
              <v-title>作业面积变化趋势</v-title>
            </div>
            <div class="boxContent">
              <div class="chart" ref="njChart"></div>
            </div>
          </div>
          <div class="zyqd">
            <div class="boxTitle">
              <v-title>作业清单</v-title>
            </div>
            <div class="boxContent">
              <div class="warnBox">
                <div class="bottomCon">
                  <div class="tableTitle flex">
                    <div style="width:20%">作业单号</div>
                    <div style="width:20%">机手</div>
                    <div style="width:20%">作业面积</div>
                    <div style="width:20%">作业时间</div>
                    <div style="width:20%">操作</div>
                  </div>
                  <div class="tableBody">
                    <ul style="height:100%">
                      <li
                        class="flex listContnet"
                        v-for="(item, index) in listData"
                        :key="index"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.djno_"
                          placement="top"
                        >
                          <div
                            style="width:20%;overflow: hidden;text-overflow: ellipsis;"
                          >
                            {{ item.djno_ }}
                          </div>
                        </el-tooltip>

                        <div style="width:20%">{{ item.djMan_ }}</div>
                        <div style="width:20%">{{ item.taskScale_ }}亩</div>
                        <div style="width:20%">
                          {{
                            $formatDate(new Date(item.djTime_), "yyyy-MM-dd")
                          }}
                        </div>
                        <!-- <div style="width:20%">
                      <span class="botText" @click="locusClick(item)">
                        查看轨迹
                      </span>
                    </div> -->
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="locusBox" v-if="locusShow">
            <div class="locusList">
              <div class="locusTitle">
                <span>作业轨迹</span>
                <el-button
                  class="warn"
                  @click="locusClose"
                  icon="el-icon-circle-close"
                ></el-button>
              </div>
              <div class="locusContent">
                <JKMap class="jMap" :load="mapLoad" :mapParams="mapParams">
                </JKMap>
                <p class="locusText">{{ upDate }}</p>
              </div>
            </div>
          </div>
        </bar-card>
      </div>
    </div>
  </v-drawer>
</template>

<script>
import { loadChart } from "./charts/njData";
import {
  getLdsmmByCodeNjWorkMj,
  getLdsmmByCodeNjInfo,
  getLdsmmTaskServiceOrder,
  getWlwNJGJ
} from "@/api/njfb";
// const mapParams = require("@/views/map/googleMap/map.config.js");
import { mapGetters } from "vuex";
// import gjPoint from "@/views/map/util/movePoint";
export default {
  data() {
    return {
      locusShow: false,
      infoList: {
        name: "李慧敏",
        phone: "15800215008",
        date: "2020-12-01",
        fyj: "180°",
        gdj: "200°",
        speed: "16m³/h",
        address: "丰智昌顺罗平种植基地"
      },
      listData: [],
      locusData: [],
      upDate: ""
    };
  },
  computed: {
    ...mapGetters(["graphic"])
  },

  mounted() {
    this.dataLoad();
  },
  watch: {
    graphic() {
      this.clearChart();
      this.dataLoad();
    }
  },
  methods: {
    dataLoad() {
      getLdsmmByCodeNjWorkMj({ orgCoopEquipmentCode: this.graphic.code }).then(
        res => {
          if (res.code === 200) {
            this.njChart = this.$echarts.init(this.$refs.njChart);
            loadChart(this.njChart, res.data);
            window.addEventListener("resize", () => {
              this.njChart.resize();
            });
          }
        }
      );
      getLdsmmByCodeNjInfo({ code: this.graphic.code }).then(res => {
        if (res.code === 200) {
          if (res.data.length != 0) {
            this.infoList.njname_ = res.data[0].njname_;
            this.infoList.name = res.data[0].name_;
            this.infoList.date = res.data[0].date_;
            this.infoList.phone = res.data[0].phone_;
            this.infoList.fyj = res.data[0].fyj_;
            this.infoList.gdj = res.data[0].gdj_;
            this.infoList.speed = res.data[0].sd_;
            this.infoList.address = res.data[0].szwz_;
          } else {
            this.infoList = {};
          }
        }
      });

      getLdsmmTaskServiceOrder({
        orgCoopEquipmentCode: this.graphic.code
      }).then(res => {
        if (res.code === 200) {
          this.listData = res.data;
        }
      });
    },
    locusClick(item) {
      this.locusShow = true;
      this.upDate = this.$formatDate(new Date(item.djTime_), "yyyy-MM-dd");
      this.param = item;
      if (this.map) {
        this.movePoint.clear();
        this.layer.clear();

        let begintime = this.$formatDate(
          new Date(this.param.beginTime_),
          "yyyy-MM-dd hh:mm:ss"
        );
        let endtime = this.$formatDate(
          new Date(this.param.endTime_),
          "yyyy-MM-dd hh:mm:ss"
        );
        getWlwNJGJ({
          begintime,
          endtime,
          sbid: this.param.sbbs_
        }).then(res => {
          if (res.code === 200) {
            let data = res.data;
            let startPoint = new window.esri.geometry.Point(
              [data[0].jd_, data[0].wd_],
              this.map.spatialReference
            );
            startPoint = window.esri.geometry.geographicToWebMercator(
              startPoint
            );
            this.map.centerAndZoom(startPoint, 18);

            setTimeout(() => {
              let icon = require("images/map/nj.png");
              let symbol = new window.esri.symbol.PictureMarkerSymbol(
                icon,
                20,
                20
              );
              let graphic = new window.esri.Graphic(
                startPoint,
                symbol,
                data[0]
              );
              this.layer.add(graphic);
              //   this.movePoint = new gjPoint(graphic);
              let pointArr = [];
              data.map(it => {
                let po = new window.esri.geometry.Point(
                  [it.jd_, it.wd_],
                  this.map.spatialReference
                );
                po = window.esri.geometry.geographicToWebMercator(po);
                pointArr.push([po.x, po.y]);
              });
              this.movePoint.moves(pointArr);
            }, 3000);
          }
        });
      }
    },
    locusClose() {
      this.locusShow = false;
      if (this.movePoint) this.movePoint.clear();
      if (this.map) this.map.destroyed();
      this.map = null;
      this.movePoint = null;
    },
    clearChart() {
      this.njChart.clear();
    },
    mapLoad(map) {
      this.map = map;

      let extent = new window.esri.geometry.Extent({
        xmax: 12395460.118342787,
        xmin: 12393828.665520463,
        ymax: 2597181.2844477124,
        ymin: 2596400.193564989,
        spatialReference: { wkid: 102100 }
      });
      map.setExtent(extent);

      let begintime = this.$formatDate(
        new Date(this.param.beginTime_),
        "yyyy-MM-dd hh:mm:ss"
      );
      let endtime = this.$formatDate(
        new Date(this.param.endTime_),
        "yyyy-MM-dd hh:mm:ss"
      );
      getWlwNJGJ({
        begintime,
        endtime,
        sbid: this.param.sbbs_
      }).then(res => {
        if (res.code === 200) {
          let data = res.data;
          let startPoint = new window.esri.geometry.Point(
            [data[0].jd_, data[0].wd_],
            map.spatialReference
          );
          startPoint = window.esri.geometry.geographicToWebMercator(startPoint);
          map.centerAndZoom(startPoint, 18);

          setTimeout(() => {
            this.layer = new window.esri.layers.GraphicsLayer("trail");
            map.addLayer(this.layer);

            let icon = require("images/map/nj.png");
            let symbol = new window.esri.symbol.PictureMarkerSymbol(
              icon,
              20,
              20
            );
            let graphic = new window.esri.Graphic(startPoint, symbol, data[0]);
            this.layer.add(graphic);
            // this.movePoint = new gjPoint(graphic);
            let pointArr = [];
            data.map(it => {
              let po = new window.esri.geometry.Point(
                [it.jd_, it.wd_],
                map.spatialReference
              );
              po = window.esri.geometry.geographicToWebMercator(po);
              pointArr.push([po.x, po.y]);
            });
            this.movePoint.moves(pointArr);
          }, 3000);
        }
      });
    },
    closeClick() {
      this.$store.dispatch("drawer/setRightComponent", "zzyDrawer");
    }
  },
  destroyed() {
    if (this.movePoint) this.movePoint.clear();
    if (this.map) this.map.destroyed();
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.locusBox
  position absolute
  width: 70%;
  height: 37%;
  bottom: 0;
  right:101%;
  background-color: rgba(24,39,80,.8);

.locusList
  padding: 10px;
  height: calc(100% - 20px);

.locusTitle
  height: 10%;
  color: #7ad8ed;
  font-size: 0.12rem;
  display: flex;
  align-items: center;
  margin-bottom 5px
  display flex
  justify-content: space-between;

.warn
  padding 0
  background transparent
  border 0
  color #7ad8ed
  font-size 22px
  z-index 9

  &:hover
    background transparent
    color #fff

.locusContent
  height: calc(90% - 5px);
  position relative

.locusImg
  height 100%
  img
    width 100%
    height 100%

.locusText
  position absolute
  top 0
  left 0
  color #fff
  padding 5px 15px
  background-color rgba(0,0,0,.7)

.jbxx
    height 30%

.zymj
    height 33%

.zyqd
    height 37%

.boxTitle
    height 15%

.boxContent
    height calc(85% - 20px)
    padding 20px 10px 0
    box-sizing border-box
.chart
    width 100%
    height 100%

.table_box
  display flex
  flex-wrap wrap
  border-bottom 1px solid #006b9d
  border-left 1px solid #006b9d
  height 100%
  box-sizing border-box

.table_list
  width calc(50% - 1px)
  display flex
  border-top 1px solid #006b9d
  border-right 1px solid #006b9d
  background-color rgba(2, 167, 237,0.2)

.table_title
  padding 5px 0
  color #00b4ff
  width 40%
  display flex
  justify-content center
  align-items center
  border-right 1px solid #006b9d
  letter-spacing 2px
  font-size .09rem

.table_info
  padding 5px 0
  color #fff
  display flex
  align-items center
  width 60%

.info
  padding-left 15px
  overflow hidden
  white-space nowrap
  text-overflow ellipsis

.table_content
  width calc(100% - 1px)
  display flex
  border-top 1px solid #006b9d
  border-right 1px solid #006b9d
  background-color rgba(2, 167, 237,0.2)

  .content_title
    color #00b4ff
    width 20%
    display flex
    justify-content center
    align-items center
    border-right 1px solid #006b9d
    letter-spacing 2px
    font-size .09rem
    padding 5px 0

  .content_info
    color #fff
    display flex
    align-items center
    width 80%
    padding 5px 0

  .infoCont
    padding 0 5px
    text-indent 0.05rem

.warnBox
  height 100%

.bottomCon
  height 100%

.boxBottom
  height 36%

.tableTitle
  background #004252
  color #fff
  padding 10px 5px
  text-align center

.tableBody
  height calc(100% - 40px)
  overflow auto
  text-align center

  &::-webkit-scrollbar
    width 4px
    background-color #00162D

  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent

  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor

  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0

.listContnet
  padding 10px 5px
  color #fff
  cursor pointer

.listContnet:nth-child(2n)
  background #042A3F

.botText
  padding: 2px 5px;
  background: #22bdf0;
  color: #000;
  border-radius: 10px;
.panel
    height 100%
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
</style>
